<div class=" overflow-hidden p-4" style="min-height: 500px;">
    <div class="row ">
        <div class="col all">

            <div class="row g-5 ">

                <div class="col-md-3 d-sm-none d-md-block" >

                    <div class="m-b-15" *ngIf="attributes.length > 0"><a class="btn btn-primary btn-block" i18n>Reset Filter</a></div>
                    <div *ngFor="let filter of attributes">
                    <div class="m-t-20" *ngIf="filter.attr_type =='multiselect'">
                        <app-product-filter-type-checkbox [attribute]="filter" [options]="filter.options"></app-product-filter-type-checkbox>
                    </div>

<!--                    <div class="m-t-20">-->
<!--                        <app-product-filter-type-checkbox></app-product-filter-type-checkbox>-->
<!--                    </div>-->

<!--                    <div class="m-t-20">-->
<!--                        <app-product-filter-type-range></app-product-filter-type-range>-->
<!--                    </div>-->

                </div>
                </div>
                <div class="col-md-9 col-sm-9  product">
                    <app-products-grid [searchKeyword]="searchKeyword" [ProductDataSet]="dataset"
                                       [isSearchGrid]="isSearchGrid"></app-products-grid>

                </div>
            </div>
        </div>
    </div>
</div>




